import { gql } from '@apollo/client';

export const FETCH_APP_DATA = gql`
    query FetchAppData($versionStatus: VersionStatusType) {
        glassesPackages(
            company: PNL
            glassesType: SUN
            versionStatus: $versionStatus
        ) {
            id
            name
            default
            multifocal
            borderless
            backgroundColorGeneral
            textColorGeneral
            priceInt
            discountPercentage
            canBeOrdered
            order
            topChoice
            featureIds
            strength
            readingArea
            addOns {
                id
                name
                description
                order
                priceInt
                excludesAddOnIds
                freeWithPackagesIds
            }
        }
        features(
            company: PNL
            glassesType: SUN
            versionStatus: $versionStatus
        ) {
            id
            name
            order
            multifocalOnly
        }
    }
`;
